import Axios from "axios";
import {
    SET_SALES_DEPARTMENT_TARGET_LIST,
    UNSET_SALES_DEPARTMENT_TARGET_LIST,
} from "@/store/mutation-types";
import { saveUpdateSalesDepartmentTarget, getSalesDepartmentTargetList } from "@/store/api";

const state = {
    getSalesDepartmentTargetList: [],
    editingSalesDepartmentTarget: null,
};

const getters = {
    getSalesDepartmentTargetList(state) {
        return state.getSalesDepartmentTargetList;
    },
    getEditingSalesDepartmentTarget(state) {
        return state.editingSalesDepartmentTarget;
    }
};

const mutations = {
    [SET_SALES_DEPARTMENT_TARGET_LIST](state, data) {
        state.getSalesDepartmentTargetList = data;
    },
    [UNSET_SALES_DEPARTMENT_TARGET_LIST](state) {
        state.getSalesDepartmentTargetList = [];
    },
    seteditingSalesDepartmentTarget(state, data) {
        state.editingSalesDepartmentTarget = data;
    }
};

const actions = {
    saveUpdateSalesDepartmentTarget({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesDepartmentTarget, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesDepartmentTargetList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesDepartmentTargetList, { params: data })
                .then(function (response) {
                    commit("SET_SALES_DEPARTMENT_TARGET_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_DEPARTMENT_TARGET_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSaleDepartmentTargetById({ commit }, data) {
        const getSaleDepartmentByIdApi = `${getSalesDepartmentTargetList}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSaleDepartmentByIdApi)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
